import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getDataACL } from "./getDataAcl";
import { updateACL } from "../config/redux/acl/aclSlice";

export const usePermissions = () => {
  const dispatch = useDispatch();
  const { data: aclData, loading } = useSelector((state) => state.acl);

  useEffect(() => {
    if (!aclData) {
      const data = getDataACL();
      dispatch(updateACL(data));
    }
  }, [dispatch, aclData]);

  const hasPermission = (code, action) => {
    if (loading) return "loading";

    if (!aclData || !aclData.menu) return false;

    const menuItem = aclData.menu.find((item) => item.code === code);

    if (menuItem) {
      const actionItem = menuItem.action_page.find((a) => a.code === action);
      return actionItem && actionItem.is_active;
    }

    for (const item of aclData.menu) {
      if (item.sub && item.sub.length > 0) {
        const subMenuItem = item.sub.find((sub) => sub.code === code);
        if (subMenuItem) {
          const actionItem = subMenuItem.action_page.find(
            (a) => a.code === action
          );
          return actionItem && actionItem.is_active;
        }
      }
    }

    return false;
  };

  return {
    hasPermission: (code, action) => hasPermission(code, action),
    hasCreatePermission: (code) => hasPermission(code, "Create"),
    hasUpdatePermission: (code) => hasPermission(code, "Update"),
    hasDeletePermission: (code) => hasPermission(code, "Delete"),
  };
};
